import { QueryClient } from "@tanstack/react-query";

// Client for all non-graphQL queries
export const reactQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // When true, every time you switch tabs it refetches API calls; we want to disable this behavior
      refetchOnWindowFocus: false,
      // Retry failed requests once
      retry: 1,
      // Note: staleTime and cacheTime are set per-query as needed
    },
  },
});
